<div class="loader">
  <xpo-busy-loader class="loader__busy-loader"></xpo-busy-loader>
</div>
